import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import AiChatAsync from './aiChatAsync';
import IQuestion from 'models/Question';

interface IState {
  userPrompt: string | null;
  content: {
    topic: string;
    questions: Pick<IQuestion, 'title' | 'answers'>[];
  } | null;
  translations: any;
};

const initialState:IState = {
  userPrompt: null,
  content: null,
  translations: null
};

const slice = createSlice({
  name: 'aiChat',
  initialState,
  reducers: {
    removeQuestion: (state, action:PayloadAction<number>) => {
      if (state.content) {
        state.content = { ...state.content, questions: state.content.questions.filter((_,i) => i !== action.payload) }
      }
    },
    changeTranslationField: (state, action) => {
      const { lng, field, value } = action.payload;

      if (state.translations[lng]) {
        state.translations[lng][field] = value;
      }
    },
    setInitialField: <IStateKey extends keyof IState>(state: IState, action: PayloadAction<IStateKey>) => {
      state[action.payload] = initialState[action.payload];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(AiChatAsync.generateQuestions.pending, (state, action) => {
      const { message } = action.meta.arg;
      state.userPrompt = message;
    })
    builder.addCase(AiChatAsync.generateQuestions.fulfilled, (state, action:PayloadAction<any>) => {
      state.content = action.payload;
    })
    builder.addCase(AiChatAsync.generateQuestion.fulfilled, (state, action) => {
      if (!action.payload || !action.payload.title || !action.payload.answers) return;
      const { arg:questionIndex } = action.meta;
      if (state.content?.questions.length === questionIndex) {
        state.content.questions.push(action.payload);
      } else if (state.content) {
        state.content = { ...state.content, questions: state.content.questions.map((q, i) => i === questionIndex ? action.payload : q) }
      }
    })
    builder.addCase(AiChatAsync.generateTranslations.fulfilled, (state, action:PayloadAction<any>) => {
      state.translations = action.payload;
    })
  }
});

export const aiChatActions = slice.actions;

export default slice.reducer;
